import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { PlatformIcon } from "@/components/PlatformTabs";

const ICONS = ["star", "grid", "instagram", "youtube", "facebook", "music"];
const COLORS = ["#F59E0B", "#38BDF8", "#34D399", "#C084FC", "#F472B6", "#F87171"];

export default function AddPlatformModal({ open, onClose, onCreated }) {
  const [name, setName] = useState("");
  const [icon, setIcon] = useState("star");
  const [color, setColor] = useState("#F59E0B");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    try {
      await api.post("/platforms", { name: name.trim(), icon, color });
      toast.success(`Platform "${name}" added`);
      setName(""); setIcon("star"); setColor("#F59E0B");
      onCreated();
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-[#0E131F] border border-slate-800 chamfered max-w-md" data-testid="add-platform-modal">
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-wide text-amber-500">
            New Platform Section
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label-mono block mb-1">Platform Name</label>
            <input
              autoFocus
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Twitter, LinkedIn, Snapchat"
              className="input-tactical w-full px-3 py-2 rounded"
              data-testid="input-platform-name"
            />
          </div>

          <div>
            <label className="label-mono block mb-2">Icon</label>
            <div className="flex flex-wrap gap-2">
              {ICONS.map((i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => setIcon(i)}
                  className={`p-2 rounded border transition ${icon === i ? "border-amber-500 bg-amber-500/10 text-amber-300" : "border-slate-800 bg-slate-900/40 text-slate-400 hover:border-slate-600"}`}
                  data-testid={`platform-icon-${i}`}
                >
                  <PlatformIcon icon={i} />
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="label-mono block mb-2">Accent Color</label>
            <div className="flex flex-wrap gap-2">
              {COLORS.map((c) => (
                <button
                  key={c}
                  type="button"
                  onClick={() => setColor(c)}
                  className="w-8 h-8 rounded-full border-2 transition"
                  style={{ background: c, borderColor: color === c ? "#F59E0B" : "transparent", boxShadow: color === c ? `0 0 0 2px ${c}44` : "none" }}
                  aria-label={c}
                />
              ))}
            </div>
          </div>

          <button
            type="submit"
            disabled={busy}
            className="btn-signal w-full py-2.5 rounded"
            data-testid="save-platform-submit-btn"
          >
            {busy ? "Adding…" : "Add Platform"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
